import React from 'react'

const Info = () => (
  <svg viewBox="0 0 24 24" role="img" aria-hidden="true" focusable="false">
    <title>Info</title>
    <g>
      <path data-name="info-primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z" />
      <path
        data-name="info-secondary"
        d="M11 12a1 1 0 0 1 0-2h2a1 1 0 0 1 .96 1.27L12.33 17H13a1 1 0 0 1 0 2h-2a1 1 0 0 1-.96-1.27L11.67 12H11zm2-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
      />
    </g>
  </svg>
)

export default Info
